import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const ccom: ImportTypeConfig = {
  type: 'ccom',
}
